import dmPortalConfig from '@dm-portal/config';
import domain from '@framework/config/domain';
import isServer from '@framework/router/Next/isServer';
import shouldUseInternalNetwork from '@framework/router/Next/shouldUseInternalNetwork';

export default {
  getRpcUrl(): string {
    if (shouldUseInternalNetwork()) {
      return this.getInternalRpcUrl();
    }

    return !isServer()
      ? `${ domain.protocol }//${ window.location.host }/proxy/order-book/rpc`
      : `${ domain.protocol }//${ domain.apiDomain }/order-book/rpc`;
  },

  getInternalRpcUrl(): string {
    return `${ dmPortalConfig.api.orderBookInternal }/order-book/rpc`;
  },
};
